import { useState, useEffect } from "react";
import "./ResponseContentNPS.css";
import { Question } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { ResponseNavigate } from "./ResponseNavigate";
import { NPSResponse } from "../config/responseSettings";
import config from "environment";
import { ResponseErrors } from "./responseErrors";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;

type ResponseContentNPSProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentNPS = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentNPSProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [score, setScore] = useState<number | undefined>(undefined);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        setScore(JSON.parse(responseValues).score || undefined);
        setError(ResponseErrors.none);
    }, [question, responseValues])

    const metRequirements = (theScore: number | undefined) : "ok" | "required" => {

        if (!question.required || (theScore !== undefined)) {
            return "ok";
        }

        if (question.required && (theScore === undefined)) {
            return "required";
        }

        return "ok"
    }

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {

        const met = metRequirements(score);

        if (met === "required") {
            setError(ResponseErrors.required);
            return;
        }

       saveResponse(score)
    }

    const saveResponse = (theScore: number | undefined) => {
        const newResponseValues: string = JSON.stringify({
            score: theScore
        } as NPSResponse);

        onSubmit(newResponseValues);
    }

    const handleScoreChange = (newScore: number) => {
        setScore(newScore);
        saveResponse(newScore);
    }

    const requirementsMet = metRequirements(score) === "ok";

    const settings = JSON.parse(question.settings);

    const min = 0;
    const max = 10; 

    const scoreArray : string [] = [];
    for (let i = min; i <= max; i++) {
        scoreArray.push(i.toString());
    }
    
    // console.log("[ResponseContentNPS] question: ", question);
    // console.log("[ResponseContentNPS] values: ", responseValues);
    // console.log("[ResponseContentNPS] text: ", text);


    return (
        <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            }
                         */}
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div style={{marginTop: "40px"}} className="form-content-score">

                {isMobileLayout &&
                    <div>0 - Not likely</div>
                }

                <div className={isMobileLayout ? "response-content-scores-grid" : "form-content-scores"}>
                    {scoreArray.map((theScore: string) => {
                        return (
                            <div 
                                key={"score-" + theScore}
                                className={"form-content-score-item" + (parseInt(theScore) === score ? " form-content-score-item-selected" : "")}
                                onClick={(e: any) => handleScoreChange(Number(theScore))}
                                data-testid={"response-content-score#" + theScore}
                            >
                                {theScore}
                            </div>
                        )
                    })}
                </div>
                {isMobileLayout &&
                    <div>10 - Very likely</div>
                }

                {!isMobileLayout &&
                    <div className="form-content-score-labels">
                        <div className="form-content-score-labels-start">
                            Not Likely
                        </div>
                        <div className="form-content-score-labels-end">
                            Very Likely
                        </div>
                    </div>
                }
            </div>    

            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit">
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

        </div>
    )
}